import { CleanShop, HardDeleteShop, MigrationDTO, ShopModel, ShopModelCreate, SyncShopShop } from "./Shop.model";

export const validation = (values: ShopModel, step: number) => {
    const errors: any = {};
    if (step === 0) {
        if (!values.name) {
            errors.name = "Owner name is required.";
        }
        if (!values.phone) {
            errors.phone = "Phone is required.";
        } else if ((values.phone).toString().length < 10 || (values.phone).toString().length > 10) {
            errors.phone = 'Invalid phone number';
        }
        if (!values.email) {
            errors.email = 'Email is Required';
        } else if (!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        }
        if (!values.username) {
            errors.username = "User Name is required.";
        } else if (values.username.length > 50) {
            errors.username = 'User Name length should be less than 50 char';
        }
    } else if (step === 1) {
        const billingError: any = {};
        if (!values?.billing?.name) {
            billingError.name = "Restaurant Name is required.";
        }
        if (!values?.billing?.address) {
            billingError.address = "Address is required.";
        }
        if (!values?.billing?.phone) {
            billingError.phone = "Phone is required.";
        } else if ((values?.billing?.phone).toString().length < 10 || (values?.billing?.phone).toString().length > 10) {
            billingError.phone = 'Invalid phone number';
        }
        if (!values?.billing?.email) {
            billingError.email = 'Email is Required';
        } else if (!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(values.email)) {
            billingError.email = 'Invalid email address';
        }
        if (values?.billing?.website && !/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(values?.billing?.website)) {
            billingError.website = 'Invalid website url';
        }
        // if (!values?.billing?.gst_no) {
        //     billingError.gst_no = 'GST No. is Required';
        // } else if (!/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(values?.billing?.gst_no)) {
        //     billingError.gst_no = 'Invalid GST No.';
        // }
        if(Object.keys(billingError).length > 0)
            errors.billing = billingError;
    }
    return errors;
};
export const validationNew = (values: ShopModelCreate, step: number) => {
    const errors: any = {};
    const validUserName = new RegExp("^[a-zA-Z0-9]*$");

    if (step === 0) {
        if (!values.name) {
            errors.name = "Owner name is required.";
        }
        if (!values.phone) {
            errors.phone = "Phone is required.";
        } else if ((values.phone).toString().length < 10 || (values.phone).toString().length > 10) {
            errors.phone = 'Invalid phone number';
        }
        if (!values.email) {
            errors.email = 'Email is Required';
        } else if (!/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        }
        if (!values.username) {
            errors.username = "User Name is required.";
        } else if(!validUserName.test(values.username)) {
            errors.username = 'Special character or space is not allowed';
        } else if (values.username.length > 50) {
            errors.username = 'User Name length should be less than 50 char';
        }
    } else if (step === 1) {
        const billingError: any = {};
        if (Object.keys(billingError).length > 0)
            errors.billing = billingError;
    }
    return errors;
};
export const validationMigration = (values: MigrationDTO) => {
    const errors: any = {};
    if (!values.from_shop_username) {
        errors.from_shop_username = "From Shop name is required.";
    }
    if (!values.to_shop_username) {
        errors.to_shop_username = "To Shop name is required.";
    }
    return errors;
};
export const validationClean = (values: CleanShop) => {
    const errors: any = {};
    if (!values.shop_username) {
        errors.from_shop_username = "Shop name is required.";
    }
    return errors;
};

export const validationHardDelete = (values: HardDeleteShop) => {
    const errors: any = {};
    if (!values.username) {
        errors.username = "Shop username is required.";
    }
    if (!values.admin_email) {
        errors.admin_email = "Admin Email is required.";
    }
    if (!values.admin_password) {
        errors.admin_password = "Admin password is required.";
    }
    return errors;
};

export const validationSyncShop = (values: SyncShopShop) => {
    const errors: any = {};
    if (!values.username) {
        errors.username = "Shop username is required.";
    }
    return errors;
};